module.exports = __webpack_public_path__ + "img/lens-150-plus-00.e0cc3997.png";